import React, { useState, useEffect, useContext } from 'react';
import { isMobileDevice, isSupportedTenantCode } from 'common/utilities/utils';
import { UserOrderContext } from 'context/context';
import TermsOfUseHeader from '../Presentation/TermsOfUseHeader';
import TermsOfUseQuestions from '../Presentation/TermsOfUseQuestions';
import { ClearCartModule } from 'organisms/ClearCartModule/Container/ClearCartComponent';

const TermsOfUseContainer = props => {
  const { contentData: { headerData = {}, questionList = [] } = {}, userParams } = props;
  const [isMobile, setMobileHeader] = useState(isMobileDevice(window.innerWidth));
  const { userOrderState } = useContext(UserOrderContext);
  const windowResized = () => {
    const isMobileView = isMobileDevice(window.innerWidth);
    setMobileHeader(isMobileView);
  };
  useEffect(() => {
    window.addEventListener('resize', windowResized);
  }, [isMobile]);
  const desktopTermsOfUse = () => {
    return (
      <div className={`terms-desktop-container ${isSupportedTenantCode() && 'terms-au'}`}>
        <div className='terms-section-left'>
          <TermsOfUseHeader headerData={headerData} userParams={userParams} />
        </div>
        <div className='terms-section-right'>
          <div className='terms-questions-desktop'>
            <TermsOfUseQuestions questionList={questionList} headerData={headerData} isMobile={isMobile} />
          </div>
        </div>
        {userOrderState.showCartClearAlert ? <ClearCartModule /> : null}
      </div>
    );
  };
  const mobileTermsOfUse = () => {
    return (
      <div className={`terms-mobile-container ${isSupportedTenantCode() && 'terms-au'}`}>
        <div className='terms-mobile-header'>
          <TermsOfUseHeader headerData={headerData} />
        </div>
        <div className='terms-mobile-questions'>
          <TermsOfUseQuestions questionList={questionList} headerData={headerData} isMobile={isMobile} />
        </div>
        {userOrderState.showCartClearAlert ? <ClearCartModule /> : null}
      </div>
    );
  };
  return isMobile ? mobileTermsOfUse() : desktopTermsOfUse();
};
export default TermsOfUseContainer;
